var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c("div", { staticClass: "form-network form-network-facebook" }, [
        _vm.hasPersonalConciergeriePage
          ? _c("details", { attrs: { open: "" } }, [
              _c("summary", [
                _vm._v(
                  _vm._s(_vm.$t("dash.post-creator.form.facebook.privacy")) +
                    " "
                ),
                _c("i", { staticClass: "fa-solid fa-caret-down" }),
              ]),
              _c(
                "div",
                { staticClass: "content-detail" },
                [
                  _c("SelectComponent", {
                    attrs: {
                      valueSelect: _vm.formDataNetwork.visibility,
                      changeValueSelect: _vm.changeVisibilityPost,
                      data: {
                        EVERYONE: _vm.$t(
                          "dash.post-creator.form.facebook.visibility-public"
                        ),
                        FRIENDS: _vm.$t(
                          "dash.post-creator.form.facebook.visibility-friends"
                        ),
                        SELF: _vm.$t(
                          "dash.post-creator.form.facebook.visibility-me"
                        ),
                      },
                      positionAuto: false,
                      positionX: "left",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(
              _vm._s(_vm.$t("dash.post-creator.form.facebook.visibility")) + " "
            ),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c("div", { staticClass: "content-detail" }, [
            _c("div", { staticClass: "list-simple-btn" }, [
              _c(
                "div",
                {
                  staticClass: "type-btn-simple",
                  on: {
                    click: function ($event) {
                      return _vm.addMode("addPlaceMode")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-solid fa-map-pin" }),
                  _c("p", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("dash.post-creator.form.facebook.place")
                        ) +
                        " \n                        "
                    ),
                    _c("span", { staticClass: "pink" }, [
                      _vm._v(
                        "(" +
                          _vm._s(
                            _vm.draftInstance.form.networks.facebook.place
                              ? "1"
                              : "0"
                          ) +
                          ")"
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
        _vm.draftInstance.form.urlsTextContentHistory.length
          ? _c("details", { attrs: { open: "" } }, [
              _c("summary", [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("dash.post-creator.form.facebook.link-preview")
                    ) +
                    "\n            "
                ),
                _c("i", { staticClass: "fa-solid fa-caret-down" }),
              ]),
              _c("div", { staticClass: "content-detail" }, [
                _c(
                  "div",
                  { staticClass: "list-thubmmail" },
                  _vm._l(
                    _vm.draftInstance.form.urlsTextContentHistory.items,
                    function (url) {
                      return _c(
                        "div",
                        {
                          key: url.value,
                          staticClass: "thubmmail",
                          on: { click: () => _vm.selectUrl(url.value) },
                        },
                        [
                          _c("Checkbox", {
                            attrs: {
                              id: url.value,
                              prefixId: "thubmmail-",
                              isChecked:
                                _vm.draftInstance.form.networks.facebook.snippet
                                  .link == url.value,
                              isDisable:
                                _vm.draftInstance.form.networks.facebook.snippet
                                  .link == url.value,
                              add: () => _vm.selectUrl(url.value),
                              remove: () => {},
                            },
                          }),
                          _c("SnippetNetwork", {
                            attrs: {
                              link: url.value,
                              imageUrlDefault: _vm.draftInstance.form.networks
                                .facebook.snippet.imageUrl
                                ? _vm.draftInstance.form.networks.facebook
                                    .snippet.imageUrl
                                : undefined,
                              titleDefault: _vm.draftInstance.form.networks
                                .facebook.snippet.title
                                ? _vm.draftInstance.form.networks.facebook
                                    .snippet.title
                                : undefined,
                              descriptionDefault: _vm.draftInstance.form
                                .networks.facebook.snippet.description
                                ? _vm.draftInstance.form.networks.facebook
                                    .snippet.description
                                : undefined,
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }